import { render, staticRenderFns } from "./PlanStep6.vue?vue&type=template&id=3b9c62fe&scoped=true"
import script from "./PlanStep6.vue?vue&type=script&lang=js"
export * from "./PlanStep6.vue?vue&type=script&lang=js"
import style0 from "./PlanStep6.vue?vue&type=style&index=0&id=3b9c62fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c62fe",
  null
  
)

export default component.exports